var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toolTip"},[_vm._t("default"),_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.content))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }